import { useState, useEffect } from "react";
import "../../../../../../styles/selectBar.css";

const SentenceSelectionPage = ({
  worksheet,
  selectedTypes,
  setSelectedTypes,
}) => {
  const [blankCount, setBlankCount] = useState(0);
  const [scrambleCount, setScrambleCount] = useState(0);
  const [compositionCount, setCompositionCount] = useState(0);
  const [translationCount, setTranslationCount] = useState(0);
  const [comprehensiveCount, setComprehensiveCount] = useState(0);

  // Get max available count for each type
  // Blank, scramble, comprehensive: from documents array
  // Composition, translation: from sentence_list array
  const documents = worksheet.data?.documents || [];
  const sentenceList = worksheet.data?.sentence_list || [];

  const maxCounts = {
    blank: documents.filter((d) => d.type === "sentence:blank_root").length,
    scramble: documents.filter((d) => d.type === "sentence:scramble_root").length,
    composition: sentenceList.length || 1,  // From sentence_list
    translation: sentenceList.length || 1,  // From sentence_list
    comprehensive: documents.filter((d) => d.type === "sentence:all_root").length || 1,
  };

  const updateTypes = () => {
    const types = [];
    if (blankCount > 0) types.push({ key: "blank", count: blankCount });
    if (scrambleCount > 0) types.push({ key: "scramble", count: scrambleCount });
    if (compositionCount > 0)
      types.push({ key: "composition", count: compositionCount });
    if (translationCount > 0)
      types.push({ key: "translation", count: translationCount });
    if (comprehensiveCount > 0)
      types.push({ key: "comprehensive", count: comprehensiveCount });

    setSelectedTypes(types);
  };

  useEffect(() => {
    updateTypes();
    // eslint-disable-next-line
  }, [blankCount, scrambleCount, compositionCount, translationCount, comprehensiveCount]);

  // Initialize with default values
  useEffect(() => {
    if (setSelectedTypes !== undefined && selectedTypes.length === 0) {
      setBlankCount(1);
      setScrambleCount(0);
      setCompositionCount(1);
      setTranslationCount(1);
      setComprehensiveCount(1);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ padding: "20px", width: "100%" }}>
      <div style={{ fontSize: "18px", paddingBottom: "16px", fontWeight: "600" }}>
        테스트 세트 설정
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {/* 빈칸 채우기 */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <label
            style={{
              fontSize: "16px",
              minWidth: "180px",
            }}
          >
            (순서 고정) 빈칸 채우기:
          </label>
          <select
            value={blankCount}
            onChange={(e) => setBlankCount(Number(e.target.value))}
            className="customSelect"
            style={{ width: "120px", fontSize: "16px" }}
          >
            {[...Array(maxCounts.blank + 1)].map((_, i) => (
              <option key={i} value={i}>
                {i}세트
              </option>
            ))}
          </select>
        </div>

        {/* 스크램블 */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <label
            style={{
              fontSize: "16px",
              minWidth: "180px",
            }}
          >
            (순서 고정) 스크램블:
          </label>
          <select
            value={scrambleCount}
            onChange={(e) => setScrambleCount(Number(e.target.value))}
            className="customSelect"
            style={{ width: "120px", fontSize: "16px" }}
          >
            {[...Array(maxCounts.scramble + 1)].map((_, i) => (
              <option key={i} value={i}>
                {i}세트
              </option>
            ))}
          </select>
        </div>

        {/* 영작 */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <label
            style={{
              fontSize: "16px",
              minWidth: "180px",
            }}
          >
            (순서 고정) 영작:
          </label>
          <select
            value={compositionCount}
            onChange={(e) => setCompositionCount(Number(e.target.value))}
            className="customSelect"
            style={{ width: "120px", fontSize: "16px" }}
          >
            {[...Array(maxCounts.composition + 1)].map((_, i) => (
              <option key={i} value={i}>
                {i}세트
              </option>
            ))}
          </select>
        </div>

        {/* 해석 */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <label
            style={{
              fontSize: "16px",
              minWidth: "180px",
            }}
          >
            (순서 고정) 해석:
          </label>
          <select
            value={translationCount}
            onChange={(e) => setTranslationCount(Number(e.target.value))}
            className="customSelect"
            style={{ width: "120px", fontSize: "16px" }}
          >
            {[...Array(maxCounts.translation + 1)].map((_, i) => (
              <option key={i} value={i}>
                {i}세트
              </option>
            ))}
          </select>
        </div>

        {/* 종합 */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <label
            style={{
              fontSize: "16px",
              minWidth: "180px",
            }}
          >
            (순서 랜덤) 종합:
          </label>
          <select
            value={comprehensiveCount}
            onChange={(e) => setComprehensiveCount(Number(e.target.value))}
            className="customSelect"
            style={{ width: "120px", fontSize: "16px" }}
          >
            {[...Array(maxCounts.comprehensive + 1)].map((_, i) => (
              <option key={i} value={i}>
                {i}세트
              </option>
            ))}
          </select>
        </div>
      </div>

      <div
        style={{
          marginTop: "20px",
          padding: "12px",
          backgroundColor: "#f5f5f5",
          borderRadius: "6px",
          fontSize: "14px",
          color: "#666",
        }}
      >
        * 각 테스트 유형별로 포함할 세트 수를 선택하세요.
        <br />* 0으로 설정하면 해당 유형은 제외됩니다.
      </div>
    </div>
  );
};

export default SentenceSelectionPage;
